<template>
  <div class="container mx-auto my-8 px-4 md:px-0">
    <base-form v-if="complex || isNew" :do="save" :v-errors="error" class="flex flex-col md:flex-row md:-mx-4" :class="{ 'justify-center': isNew }">

      <div class="w-full bg-white content shadow mb-6 md:mb-0 md:mx-4 md:w-2/3">
        <div class="group">
          <div class="fields flex flex-col w-full p-6">
            <div class="flex flex-wrap mx-0 md:-mx-2">
              <text-input class="w-full md:w-1/2 md:px-2" label="Naam" name="name" type="text"
                v-model="complex.name"
                v-validate="'required'"
                data-vv-as="Naam"
                :error="errors.first('name')"
                :has-permission="true"
                :required="true"
              ></text-input>
              <autocomplete-input
                v-if="loaded"
                class="w-full md:w-1/2 md:px-2"
                label="Organisatie"
                css="padding-right: 77px;"
                name="owner"
                v-model="contact"
                :items="contactNames"
                :isAsync="true"
                @changed="onOwnerChanged"
              ></autocomplete-input>
            </div>
            <div class="field-group mt-4" :class="{ 'has-error': errors.has('desc') }">
              <label for="desc">Beschrijving</label>
              <textarea class="textarea" id="desc" name="desc" rows="5" data-vv-as="Beschrijving" v-model="complex.desc"></textarea>
              <span class="block form-error text-xs mt-1" v-if="errors.has('desc')">
                {{ errors.first('desc') }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex w-full px-6 py-6 bg-grey-lightest border-t border-grey-lighter flex items-center">
          <button v-if="!isNew" tabindex="-1" type="button" class="text-sm text-red hover:underline" @click="destroy()">
            <span>Verwijder</span>
            <span class="hidden md:inline ml-1">Complex</span>
          </button>
          <button type="submit" class="btn py-3 text-sm text-white bg-green-dark font-semibold ml-auto">
            <span>{{ isNew ? 'Bewaren' : 'Wijzig' }}</span>
            <span class="hidden md:inline ml-1">Complex</span>
          </button>
        </div>
      </div>

      <div class="flex flex-col w-full z-0 md:mx-4 md:w-1/3" v-if="complex.created_at">
        <!-- CREATED -->
        <div class="w-full mb-4 shadow" style="background-color: #e7eef3;">
          <div class="field w-full px-4 pt-4 pb-2">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gemaakt op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ complex.created_at }}</span>
            </div>
          </div>
          <div class="field w-full px-4 py-2 pt-2 pb-4">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gewijzigd op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ complex.updated_at }}</span>
            </div>
          </div>
        </div>
      </div>
    </base-form>
    <base-notification
      :type="notification.type"
      :message.sync="notification.message"
    ></base-notification>
  </div>
</template>

<script>
import ContactService from '@/services/contact';
import ComplexService from '@/services/complex';
import SubjectService from '@/services/subject';
import ComplexPerimeter from '@/perimeters/complex';

import BaseForm from '@/components/globals/BaseForm';
import BaseNotification from '@/components/globals/BaseNotification';
import AutocompleteInput from '@/components/inputs/Autocomplete';
import TextInput from '@/components/inputs/Text';

export default {
  name: 'ComplexEdit',
  perimeters: [ComplexPerimeter],
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    BaseNotification,
    AutocompleteInput,
    TextInput
  },
  data() {
    return {
      complex: {},
      error: {},
      notification: {
        type: 'info',
        message: ''
      },
      isNew: false,
      contacts: [],
      contactNames: [],
      contact: '',
      retry: true,
      loaded: false
    };
  },
  created() {
    this.fetchComplex();
  },
  methods: {
    async fetchComplex() {
      if (!this.$route.params.id) {
        this.loaded = true;
        return (this.isNew = true);
      }

      const { data } = await ComplexService.get(this.$route.params.id).catch(
        () => {
          this.notification.type = 'error';
          this.notification.message = 'Complex niet ingeladen';
        }
      );

      this.complex = data.data;
      if (this.complex.owner && this.complex.owner.contact) {
        this.contact = this.complex.owner.contact.name;
      }

      this.loaded = true;
    },
    async save() {
      try {
        if (this.isNew) {
          console.log(this.complex, this.contacts);
          this.complex.owner = {
            contact: this.contacts[0]
          }
        } else {
          if (this.complex.owner !== null) {
            this.complex.owner.contact.name = this.contact;
          }
        }

        let contact_id = null;

        if (this.contacts.length > 0) {
          contact_id = this.contacts.find(item => this.contact === item.name);
        } else {
          const { data: response } = await ContactService.search(this.contact);
          contact_id = response.data[0];
        }

        this.complex.type = 'complex';

        if (this.isNew) {
          const { data: response } = await ComplexService.save(null, this.complex);
          await SubjectService.owner(response.data.id, contact_id.id);
        } else {
          await SubjectService.owner(this.complex.id, contact_id.id);
          await ComplexService.save(this.complex.id, this.complex);
        }

        this.notification.type = 'success';
        this.notification.message = 'Complex opgeslagen, verwerking duurt een moment.';
        return;
      } catch (response) {
        // this.error = response.data;

        this.notification.type = 'error';
        this.notification.message = 'Complex niet opgeslagen';
      }
    },
    async destroy() {
      if (confirm('Weet u zeker dat u dit complex wilt verwijderen? Na het verwijderen zijn wijzigingen niet direct zichtbaar.')) {
        try {
          await ComplexService.delete(this.complex.id);
          return this.$router.push({ name: 'complexes' });
        } catch (response) {
          this.error = response.data;

          this.notification.type = 'error';
          this.notification.message = 'Complex niet verwijderd.';
        }
      }
    },
    async onOwnerChanged(value) {
      if (value.length < 3) return (this.retry = true);

      if (!this.contactNames.length && !this.retry)
        return (this.contactNames = []);

      const { data: response } = await ContactService.search(value);
      this.contacts = response.data;
      this.contactNames = response.data.map(contact => {
        return contact.name;
      });

      if (!this.contactNames.length) {
        this.retry = false;
      }
    }
  }
};
</script>
